import { OfferContent } from '@Atomic/organisms/offer/OfferContent';

const Offer = () => <OfferContent />;

export default Offer;
